import Logo from '../Logo/Logo';
import './SiteFooter.css';

function SiteFooter() {
  return (
    <footer className="footer">
      <div>
        <Logo />
      </div>
      <nav aria-label="Footer navigation">
        <a href="/#how">How it works</a>
        <a href="/#exercises">Exercises</a>
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms</a>
      </nav>
      <div className="footer-legal">
        <p>© 2026 RELI. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default SiteFooter;
